<template>
    <div>
        <v-layout row wrap justify-center mb-5>
            <v-flex xs12 class="content content-1">
                <v-layout   wrap row 
                            justify-center 
                            align-center text-center class=""
                            mb-2
                    >
                    <v-flex xs12 mt-5 
                            class="animated bounceIn dura-3"
                            >
                        <h1 class="tittle-big">
                            Gestión de <span class="title-big-sub">crisis</span> y <br><span class="title-big-sub">continuidad del negocio</span>
                        </h1>
                    </v-flex>
                    <v-flex xs9 mt-1 
                            class="animated bounceIn dura-3 portada-linea"
                            >
                        <img :src="require('../assets/presentacion/linea.png')" alt="">
                    </v-flex>
                </v-layout>
                <v-layout   wrap row mt-5 
                            justify-center
                            align-center
                            class="portada-logo-montanas">
                    <v-flex xs12>
                        <img    class="img-logo animated fadeInUp dura-3" 
                                :src="require('@/assets/presentacion/montanas.png')"
                                alt=""
                        >
                    </v-flex>
                </v-layout>
                <v-layout wrap row mt-3 justify-center align-end
                            class="portada-logo-estructura">
                    <v-flex xs12 class="portada-logo-estructura-sub">
                        <img class="img-logo animated fadeInUp dura-2"
                                :src="require('@/assets/presentacion/estructuras.png')" alt="">
                        </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12  class="content content-2">
                <v-layout wrap row justify-center class="subcontent">
                    <v-flex xs11 mt-3>
                        <p  id="parrafo-1" class="animated slower" style="opacity:0">
                            Profundicemos en el <span class="instruccion">Ciclo de Resiliencia Organizacional</span> que, 
                            como vimos anteriormente, consta de cuatro etapas: Prevención, 
                            Preparación, Respuesta y Recuperación. Cada una de estas fases comprende elementos
                            claves que intervienen en el entendimiento y buena práctica de la 
                            Gestión de Crisis y Continuidad.
                        </p>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 class="content content-22">
                <v-layout wrap row justify-center class="subcontent">
                    <v-flex xs11 mt-3>
                        <v-layout wrap row justify-center align-center >
                            <v-flex xs7 sm4 id="svg-00" class="animated slower">
                                <Svg0App/>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-flex>
            <div class="content-triangulo">
                <v-flex xs12 class="subcontent-triangulo">
                    <div class="content content-3"></div>
                </v-flex>
            </div>
            <v-flex xs12 class="content content-6">
                <v-layout wrap row justify-center class="subcontent">
                    <v-flex xs12 mt-3>
                        <div class="cont-title">
                            <h1 id="num-2" class="circle animated slower">1</h1>
                            <h1 id="title-2" class="title-sub animated slower">Preparación</h1>
                        </div>
                    </v-flex>
                    <v-flex xs10 mt-3>
                        <v-layout wrap row justify-center align-center>
                            <v-flex xs7 sm4 v-show="$vuetify.breakpoint.xs" id="svg-20" class="animated slower">
                                <Svg2App/>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap row justify-center align-center v-if="mostrarLetrero[1]" class="card-modal">
                            <v-flex xs12 v-show="!$vuetify.breakpoint.xs" class="card-parent">
                                <div class="card-son">
                                    <div class="card-parrafo">
                                        <h3 class="card-parrafo-titulo" v-html="textoBtn"></h3>
                                        <p v-if="textoMensaje!=''" class="card-parrafo-texto" v-html="textoMensaje"></p>
                                        <ul v-if="lista.length !=0">
                                            <li v-for="(li, i) in lista" :key="'lista-'+i">
                                                <span v-html="li"></span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap row justify-around align-center>
                            <v-flex xs4 sm4 v-show="!$vuetify.breakpoint.xs" id="svg-21" class="animated slower">
                                <Svg2App/>
                            </v-flex>
                            <v-spacer v-show="!$vuetify.breakpoint.xs"></v-spacer>
                            <v-flex xs12 sm7>
                                <p id="texto-2" class="animated slower" style="opacity:0">
                                    En estafase seconstruyen los planes derespuestay se entrena al personal en dichos planes
                                </p>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs10 mt-3>
                        <v-layout wrap row justify-center v-show="!$vuetify.breakpoint.xs">
                            <v-flex xs6 md3 mb-2 v-for="(item, idx) in seccionBtn2" :key="`btn2-${idx}`">
                                <div    :class="['btn animated slower',`dura-${idx+1}` ]" :id="`btn2-1${idx+1}`"
                                        class="btn" @mouseover="mostrarInformacion(contTextos,1, idx, seccionBtn2)"
                                        @mouseout="salir(1)">
                                    <span v-html="item.titulo"></span>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap row justify-center v-show="$vuetify.breakpoint.xs">
                            <v-flex xs6 md3 mb-2 v-for="(item, idx) in seccionBtn2" :key="`btn2-${idx}`">
                                <div    :class="['btn animated slower',`dura-${idx+1}` ]" :id="`btn2-2${idx+1}`"
                                        class="btn" @click="mostrarInformacionModal(contTextos,1, idx, seccionBtn2)">
                                    <span v-html="item.titulo"></span>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout >
            </v-flex>
            <div class="content-triangulo">
                <v-flex xs12 class="subcontent-triangulo">
                    <div class="content content-7"></div>
                </v-flex>
            </div>
            <v-flex xs12 class="content content-4">
                <v-layout wrap row justify-center class="subcontent">
                    <v-flex xs12 mt-3>
                        <div class="cont-title trigger">
                            <h1 id="num-1" class="circle animated slower">2</h1>
                            <h1 id="title-1" class="title-sub animated slower">Prevención</h1>
                        </div>
                    </v-flex>
                    <v-flex xs11 mt-3>
                        <v-layout wrap row justify-center align-center >
                            <v-flex xs7 sm4 v-show="$vuetify.breakpoint.xs" id="svg-10" class="animated slower">
                                <Svg1App/>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap row justify-center align-center v-if="mostrarLetrero[0]" class="card-modal">
                            <v-flex xs12 v-show="!$vuetify.breakpoint.xs" class="card-parent">
                                <div class="card-son">
                                    <div class="card-parrafo">
                                        <h3 class="card-parrafo-titulo" v-html="textoBtn"></h3>
                                        <p v-if="textoMensaje!=''" class="card-parrafo-texto" v-html="textoMensaje"></p>
                                        <ul v-if="lista.length !=0">
                                            <li v-for="(li, i) in lista" :key="'lista-'+i">
                                                <span v-html="li"></span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap row justify-around align-center>
                            <v-flex xs4 sm4 v-show="!$vuetify.breakpoint.xs" id="svg-11" class="animated slower">
                                <Svg1App/>
                            </v-flex>
                            <v-spacer v-show="!$vuetify.breakpoint.xs"></v-spacer>
                            <v-flex xs12 sm7 >
                                <p id="texto-1" class="animated slower" style="opacity:0">
                                    Esta etapa es un proceso continuo al cual le subyace el ciclo de gestión 
                                    Planear, Ejecutar, Verificar y Actuar. Es esencial asociar la etapa de 
                                    Prevención con un análisis integral de los riesgos de la organización
                                </p>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs10 mt-3>
                        <v-layout wrap row justify-center v-show="!$vuetify.breakpoint.xs">
                            <v-flex xs6 md3 mb-2 v-for="(item, idx) in seccionBtn1" 
                                    :key="`btn1-${idx}`" >
                                <div    :class="['btn animated slower',`dura-${idx+1}` ]" :id="`btn1-1${idx+1}`"
                                        @mouseover="mostrarInformacion(contTextos,0, idx, seccionBtn1)"
                                        @mouseout="salir(0)">
                                    <span v-html="item.titulo"></span>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap row justify-center v-show="$vuetify.breakpoint.xs">
                            <v-flex xs6 md3 mb-2 v-for="(item, idx) in seccionBtn1" 
                                    :key="`btn1-${idx}`" >
                                <div :class="['btn animated slower',`dura-${idx+1}` ]" :id="`btn1-2${idx+1}`"
                                    @click="mostrarInformacionModal(contTextos,0, idx, seccionBtn1)">
                                    <span v-html="item.titulo"></span>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout >
            </v-flex>
            <div class="content-triangulo">
                <v-flex xs12 class="subcontent-triangulo">
                    <div class="content content-5"></div>
                </v-flex>
            </div>
            <v-flex xs12 class="content content-8">
                <v-layout wrap row justify-center class="subcontent">
                    <v-flex xs12 mt-3>
                        <div class="cont-title">
                            <h1 id="num-3" class="circle animated slower">3</h1>
                            <h1 id="title-3" class="title-sub animated slower">Respuesta</h1>
                        </div>
                    </v-flex><v-flex xs10 mt-3>
                        <v-layout wrap row justify-center align-center>
                            <v-flex xs10 v-show="$vuetify.breakpoint.xs" id="svg-30" class="animated slower">
                                <Svg3App v-if="verSvg"/>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap row justify-center align-center v-if="mostrarLetrero[2]" class="card-modal">
                            <v-flex xs12 v-show="!$vuetify.breakpoint.xs" class="card-parent">
                                <div class="card-son">
                                    <div class="card-parrafo">
                                        <h3 class="card-parrafo-titulo" v-html="textoBtn"></h3>
                                        <p v-if="textoMensaje!=''" class="card-parrafo-texto" v-html="textoMensaje"></p>
                                        <ul v-if="lista.length !=0">
                                            <li v-for="(li, i) in lista" :key="'lista-'+i">
                                                <span v-html="li"></span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap row justify-center align-center>
                            <v-flex xs10 v-show="!$vuetify.breakpoint.xs" id="svg-31" class="animated slower">
                                <Svg3App v-if="verSvg"/>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs10 mt-3>
                        <v-layout wrap row justify-center v-show="!$vuetify.breakpoint.xs">
                            <v-flex xs6 md3 mb-2 v-for="(item, idx) in seccionBtn3" :key="`btn3-${idx}`">
                                <div    :class="['btn animated slower',`dura-${idx+1}` ]" :id="`btn3-1${idx+1}`"
                                        class="btn" @mouseover="mostrarInformacion(contTextos,2, idx, seccionBtn3)"
                                        @mouseout="salir(2)">
                                    <span v-html="item.titulo"></span>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap row justify-center v-show="$vuetify.breakpoint.xs">
                            <v-flex xs6 md3 mb-2 v-for="(item, idx) in seccionBtn3" :key="`btn3-${idx}`">
                                <div :class="['btn animated slower',`dura-${idx+1}` ]" :id="`btn3-2${idx+1}`"
                                        class="btn" @click="mostrarInformacionModal(contTextos,2, idx, seccionBtn3)">
                                    <span v-html="item.titulo"></span>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout >
            </v-flex>
            <div class="content-triangulo">
                <v-flex xs12 class="subcontent-triangulo">
                    <div class="content content-9"></div>
                </v-flex>
            </div>
            <v-flex xs12 class="content content-10">
                <v-layout wrap row justify-center class="subcontent">
                    <v-flex xs12 mt-3>
                        <div class="cont-title">
                            <h1 id="num-4" class="circle animated slower">4</h1>
                            <h1 id="title-4" class="title-sub animated slower">Mejora continua</h1>
                        </div>
                    </v-flex>
                    <v-flex xs10 mt-3>
                        <v-layout wrap row justify-center align-center>
                            <v-flex xs7 sm4 v-show="$vuetify.breakpoint.xs" id="svg-40" class="animated slower">
                                <Svg4App/>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap row justify-center align-center v-if="mostrarLetrero[3]" class="card-modal">
                            <v-flex xs12 v-show="!$vuetify.breakpoint.xs" class="card-parent">
                                <div class="card-son">
                                    <div class="card-parrafo">
                                        <h3 class="card-parrafo-titulo" v-html="textoBtn"></h3>
                                        <p v-if="textoMensaje!=''" class="card-parrafo-texto" v-html="textoMensaje"></p>
                                        <ul v-if="lista.length !=0">
                                            <li v-for="(li, i) in lista" :key="'lista-'+i">
                                                <span v-html="li"></span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap row justify-around align-center>
                            <v-flex xs4 sm4 v-show="!$vuetify.breakpoint.xs" id="svg-41" class="animated slower">
                                <Svg4App/>
                            </v-flex>
                            <v-spacer v-show="!$vuetify.breakpoint.xs"></v-spacer>
                            <v-flex xs12 sm7>
                                <p id="texto-4" class="animated slower" style="opacity:0">
                                    La esencia de la recuperación no es necesariamente “un retorno 
                                    a la normalidad”. Esto puede significar avanzar hacia un nuevo 
                                    modelo de negocio y nuevas estructuras organizativas que representan
                                    una nueva normalidad.
                                </p>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs10 mt-3>
                        <v-layout wrap row justify-center v-show="!$vuetify.breakpoint.xs">
                            <v-flex xs6 md3 mb-2 v-for="(item, idx) in seccionBtn4" :key="`btn4-${idx}`">
                                <div  :class="['btn animated slower',`dura-${idx+1}` ]" :id="`btn4-1${idx+1}`"
                                        class="btn" @mouseover="mostrarInformacion(contTextos,3, idx, seccionBtn4)"
                                        @mouseout="salir(3)">
                                    <span v-html="item.titulo"></span>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap row justify-center v-show="$vuetify.breakpoint.xs">
                            <v-flex xs6 md3 mb-2 v-for="(item, idx) in seccionBtn4" :key="`btn4-${idx}`">
                                <div    :class="['btn animated slower',`dura-${idx+1}` ]" :id="`btn4-2${idx+1}`"
                                        class="btn" @click="mostrarInformacionModal(contTextos,3, idx, seccionBtn4)">
                                    <span v-html="item.titulo"></span>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout >
            </v-flex>
            <div class="content-triangulo">
                <v-flex xs12 class="subcontent-triangulo">
                    <div class="content content-11"></div>
                </v-flex>
            </div>
        </v-layout>
        <!-- MODAL -->
        <modal-infografia-app v-model="modal">
            <template slot="modaltittle"></template>
            <template slot="modalcontent">
                <div class="card-parrafo">
                    <h3 class="card-parrafo-titulo" v-html="textoBtn"></h3>
                    <br>
                    <p v-if="textoMensaje!=''" class="card-parrafo-texto" v-html="textoMensaje"></p>
                    <ul v-if="lista.length !=0">
                        <li v-for="(li, i) in lista" :key="'lista-'+i">
                            <span v-html="li"></span>
                        </li>
                    </ul>
                </div>
            </template>
        </modal-infografia-app>
    </div>
</template>
<script>
import nextConditions from "../js/mixins/nextConditions";
export default {
  mixins: [nextConditions],
    data(){
        return{
            seccionBtn1:[
                {titulo: '¿Qué es prevención?' },
                {titulo: '¿Qué equipos intervienen?'},
                {titulo: '¿Qué insumos se requieren?'},
                {titulo: '¿Cuáles son los entregables?'},
            ],
            seccionBtn2:[
                {titulo: '¿Qué es preparación?' },
                {titulo: '¿Qué equipos intervienen?'},
                {titulo: '¿Qué insumos se requieren?'},
                {titulo: '¿Cuáles son los entregables?'},
            ],
            seccionBtn3:[
                {titulo: '¿Qué es respuesta?' },
                {titulo: '¿Qué equipos intervienen?'},
                {titulo: '¿Qué insumos se requieren?'},
                {titulo: '¿Cuáles son los entregables?'},
            ],
            seccionBtn4:[
                {titulo: '¿Qué es mejora continua?' },
                {titulo: '¿Qué equipos intervienen?'},
                {titulo: '¿Qué insumos se requieren?'},
                {titulo: '¿Cuáles son los entregables?'},
            ],
            contTextos:[
                {    
                    /* Contenido 1 */
                    contenido:[
                        {
                            textos:`
                                    La prevención significa anticipar, evaluar y tomar acción sobre situaciones específicas 
                                    que puedan generar incidentes o crisis. En estafase definimos las amenazas y 
                                    escenarios más críticos para la organización y aseguramos las capacidades para
                                    responder a estos.
                                `,
                            lista:[]
                        },
                        {
                            textos:`
                                El Comité de Crisis (CDC), Equipo de Soporte al Negocio (ESN) y el Equipo de Manejo de Incidentes (EMI).
                            `,
                            lista:[]
                        },
                        {
                            textos:``,
                            lista:[
                                'Identificación de amenazas e impactos potenciales',
                                'Evaluar e implementar las medidas de mitigación (eliminación/reducción) del riesgo',
                                'Monitoreo de alarmas o incidentes',
                                'Identificación de procesos y actividades críticas, de impactos financieros, regulatorios y de reputación en el negocio si esos procesos son alterados  o se vuelven inoperables.',
                                'Sesión semanal comité preventivo de Crisis',
                            ]
                        },
                        {
                            textos:'',
                            lista:[
                                'Análisis de impacto al Negocio',
                                'Análisis de Riesgo (BIA-RIA)'
                            ]
                        }
                    ],
                },
                {    
                    /* Contenido 2 */
                    contenido:[
                        {
                            textos:`
                                La organización comienza con la fase de preparación con el desarrollo de los escenarios 
                                asociados con los riesgos previamente identificados y aceptados por la gerencia de la 
                                empresa. La descripción detallada de los escenarios permite identificar los recursos de 
                                respuesta para cumplir con las expectativas de la estrategia del negocio.
                            `,
                            lista:[]
                        },
                        {
                            textos:`
                                El Comité de Crisis (CDC), Equipo de Soporte al Negocio (ESN) y el Equipo de Manejo de Incidentes (EMI).
                                `,
                            lista:[]
                        },
                        {
                            textos:``,
                            lista:[
                                'Diseño e implementación de estrategias',
                                'Desarrollo de Planes de Continuidad de Negocio y Planes de respuesta',
                                'Capacitación del personal en los planes de continuidad y de respuesta',
                                'Ejercicios y pruebaso	Identificación de procesos y actividades críticas, de impactos financieros, regulatorios y de reputación en el negocio si esos procesos son alterados  o se vuelven inoperables',
                                'Sesión semanal comité preventivo de Crisis'

                            ]
                        },
                        {
                            textos:``,
                            lista:[
                                'Diseño e implementación de estrategias',
                                'Documentación de los planes de gestión C&C',
                                'Informe de Ejercicios y pruebas ejecutados',
                                'Capacitación Gestor de Información y Líder CMC',
                                'Capacitación CCE, ESN y EMI',
                            ]
                        }
                    ],
                },
                {    
                    /* Contenido 3 */
                    contenido:[
                        {
                        textos:`
                                En la fase de respuesta el objetivo principal es proveer los recursos y 
                                herramientas para posibilitar una respuesta segura, eficaz y coordinada 
                                frente a las emergencias y/o incidentes. El objetivo primario frente a 
                                un incidente será proteger a los empleados, contratistas y personas en general,
                                y si fuese posible limitar el impacto al medio ambiente y los activos de la
                                empresa.
                        `,
                        lista:[]
                        },
                        {
                            textos:`
                                El Comité de Crisis (CDC), Equipo de Soporte al Negocio (ESN) y el Equipo de Manejo de Incidentes (EMI).
                            `,
                            lista:[]
                        },
                        {
                            textos:``,
                            lista:[
                                'Procesos de notificación, activación, y escalamiento',
                                'Estructura organizacional de respuesta',
                                'Roles y responsabilidades',
                                'Comunicaciones de crisis (internas y externas)',
                                'Gestión de los medios',
                                'Mitigar Impactos / Operar Alternamente',
                                'Reanudar y retornar a operación normal'
                            ]
                        },
                        {
                            textos:``,
                            lista:[
                                        'Instructivo Comité de Crisis Preventivo/respuesta',
                                        'Instructivo para el funcionamiento del equipo de soporte al negocio',
                                        'Guía de gestión de emergencias',
                                        'Ficha de alternativas PCO',
                            ]
                        }
                    ],
                },
                {    
                    /* Contenido 4 */
                    contenido:[
                        {
                            textos:
                            `
                                Se debe asegurar que la planificación estratégica para la mejora continua comience tan pronto como sea posible y que estas consideraciones de mejora continua se reflejen en la respuesta. <br><br>
                                El primer objetivo de la fase de mejora continua es tener al negocio nuevamente en operación. El segundo, es aprender de lo sucedido e implementar las lecciones aprendidas para que el negocio sea más seguro y mejor.<br><br>
                                La mejora continua presenta una oportunidad para regenerar, restructurar o realinear una organización.
                            `,
                            lista:[]
                        },
                        {
                            textos:`
                                El Comité de Crisis (CDC), Equipo de Soporte al Negocio (ESN) y el Equipo de Manejo de Incidentes (EMI).
                            `,
                            lista:[]
                        },
                        {
                            textos:``,
                            lista:[
                                'Planear mediciones y evaluaciones',
                                'Medir e identificar brechas',
                                'Construir acciones de mejora',
                                'Divulgar o implementar mejoras',
                            ]
                        },
                        {
                            textos:``,
                            lista:[
                                'Ciclo de mejora continua mediante la integración de lecciones aprendidas y mejores prácticas identificadas',
                                'Evaluación de Capacidad de Respuesta de Continuidad'
                            ]
                        },
                    ],
                },
            ],
            mostrarLetrero:Array(4).fill(false),
            textoMensaje:'',
            modal:false,
            textoBtn:'',
            lista:[],
            vistos:Array(16).fill(false),
            verSvg:false,
            bloque:Array(5).fill(false)
        }
    },
    components:{
        Svg0App:() => import('./infografia/0'),
        Svg1App:() => import('./infografia/1'),
        Svg2App:() => import('./infografia/2'),
        Svg3App:() => import('./infografia/3'),
        Svg4App:() => import('./infografia/4'),
    },
    props:{
        valuescroll: {
            type: Number,
            default: 0,
        },
        totalscroll:{
            type: Number,
            default: 0,
        },
        hescroll:{
            type: Number,
            default: 0,
        }
    },
    watch:{
        valuescroll(){
            this.handleScroll()
        }
    },
    methods:{
        mostrarInformacion(listaContenido, seccion, idx, btn){
            this.$set(this.mostrarLetrero,seccion,true)
            this.textoMensaje = listaContenido[seccion].contenido[idx].textos
            this.lista = listaContenido[seccion].contenido[idx].lista
            this.textoBtn=btn[idx].titulo
            if (seccion === 0) {
                this.$set(this.vistos, idx, true)
            }
            if (seccion === 1) {
                this.$set(this.vistos, (idx+4), true)
            }
            if (seccion === 2) {
                this.$set(this.vistos, (idx+8), true)
            }
            if (seccion === 3) {
                this.$set(this.vistos, (idx+12), true)
            }
        },
        salir(seccion){
            this.$set(this.mostrarLetrero,seccion,false)
        },
        mostrarInformacionModal(listaContenido, seccion, idx, btn){
            this.modal = true
            this.textoMensaje = listaContenido[seccion].contenido[idx].textos
            this.lista = listaContenido[seccion].contenido[idx].lista
            this.textoBtn=btn[idx].titulo
            this.$set(this.mostrarLetrero,seccion,true)
        },
        handleScroll(){
            var totalsc =  this.hescroll - this.totalscroll 
            console.log(totalsc +' ddd '+  this.valuescroll )
            /** */
            var parrafo = document.getElementById('parrafo-1')
            var svg00 = document.getElementById('svg-00')
            if (this.valuescroll > 30) {
                parrafo.style.opacity=1
                parrafo.classList.remove('fadeOutLeft')
                parrafo.classList.add('fadeInLeft')
                svg00.style.opacity=1
                svg00.classList.remove('zoomOut')
                svg00.classList.add('zoomIn')
                this.$set(this.bloque, 0,true)
            }else if (this.valuescroll < 200 && this.bloque[0]){
                parrafo.classList.remove('fadeInLeft')
                parrafo.classList.add('fadeOutLeft')
                svg00.classList.remove('zoomIn')
                svg00.classList.add('zoomOut')
            }
            /** Bloque 1 **/
            var num1 = document.getElementById('num-1')
            var title1 = document.getElementById('title-1')
            var svg10 = document.getElementById('svg-10')
            var svg11 = document.getElementById('svg-11')
            var texto1 = document.getElementById('texto-1')
            var btn111 = document.getElementById('btn1-11')
            var btn112 = document.getElementById('btn1-12')
            var btn113 = document.getElementById('btn1-13')
            var btn114 = document.getElementById('btn1-14')
            var btn121 = document.getElementById('btn1-21')
            var btn122 = document.getElementById('btn1-22')
            var btn123 = document.getElementById('btn1-23')
            var btn124 = document.getElementById('btn1-24')

            if (this.valuescroll > 850) {
                num1.style.opacity=1
                title1.style.opacity=1
                num1.classList.remove('fadeOutLeft')
                num1.classList.add('fadeInLeft')
                title1.classList.remove('fadeOutRight')
                title1.classList.add('fadeInRight')
            }else if (this.valuescroll < 750 && this.bloque[1]){
                num1.classList.remove('fadeInLeft')
                num1.classList.add('fadeOutLeft')
                title1.classList.remove('fadeInRight')
                title1.classList.add('fadeOutRight')
            }

            if (this.valuescroll > 950) {
                svg10.style.opacity=1
                svg11.style.opacity=1
                texto1.style.opacity=1
                svg10.classList.remove('zoomOut')
                svg10.classList.add('zoomIn')
                svg11.classList.remove('zoomOut')
                svg11.classList.add('zoomIn')
                texto1.classList.remove('zoomOut')
                texto1.classList.add('zoomIn')
            }else if (this.valuescroll < 850 && this.bloque[1]){
                svg10.classList.remove('zoomIn')
                svg10.classList.add('zoomOut')
                svg11.classList.remove('zoomIn')
                svg11.classList.add('zoomOut')
                texto1.classList.remove('zoomIn')
                texto1.classList.add('zoomOut')
            }

            if (this.valuescroll > 950) {
                this.$set(this.bloque, 1,true)
                btn111.style.opacity=1
                btn112.style.opacity=1
                btn113.style.opacity=1
                btn114.style.opacity=1
                btn121.style.opacity=1
                btn122.style.opacity=1
                btn123.style.opacity=1
                btn124.style.opacity=1
                btn111.classList.remove('noclick')
                btn112.classList.remove('noclick')
                btn113.classList.remove('noclick')
                btn114.classList.remove('noclick')
                btn111.classList.remove('bounceOut')
                btn111.classList.add('bounceInLeft')
                btn112.classList.remove('bounceOut')
                btn112.classList.add('bounceInDown')
                btn113.classList.remove('bounceOut')
                btn113.classList.add('bounceInUp')
                btn114.classList.remove('bounceOut')
                btn114.classList.add('bounceInRight')

                btn121.classList.remove('noclick')
                btn122.classList.remove('noclick')
                btn123.classList.remove('noclick')
                btn124.classList.remove('noclick')
                btn121.classList.remove('bounceOut')
                btn121.classList.add('bounceInLeft')
                btn122.classList.remove('bounceOut')
                btn122.classList.add('bounceInDown')
                btn123.classList.remove('bounceOut')
                btn123.classList.add('bounceInUp')
                btn124.classList.remove('bounceOut')
                btn124.classList.add('bounceInRight')
            }else if (this.valuescroll < 850  && this.bloque[1]){
                btn111.classList.add('noclick')
                btn112.classList.add('noclick')
                btn113.classList.add('noclick')
                btn114.classList.add('noclick')
                btn111.classList.remove('bounceInLeft')
                btn111.classList.add('bounceOut')
                btn112.classList.remove('bounceInDown')
                btn112.classList.add('bounceOut')
                btn113.classList.remove('bounceInUp')
                btn113.classList.add('bounceOut')
                btn114.classList.remove('bounceInRight')
                btn114.classList.add('bounceOut')


                btn121.classList.add('noclick')
                btn122.classList.add('noclick')
                btn123.classList.add('noclick')
                btn124.classList.add('noclick')
                btn121.classList.remove('bounceInLeft')
                btn121.classList.add('bounceOut')
                btn122.classList.remove('bounceInDown')
                btn122.classList.add('bounceOut')
                btn123.classList.remove('bounceInUp')
                btn123.classList.add('bounceOut')
                btn124.classList.remove('bounceInRight')
                btn124.classList.add('bounceOut')
            }


            /** Bloque 2 **/
            var num2 = document.getElementById('num-2')
            var title2 = document.getElementById('title-2')
            var svg20 = document.getElementById('svg-20')
            var svg21 = document.getElementById('svg-21')
            var texto2 = document.getElementById('texto-2')
            var btn211 = document.getElementById('btn2-11')
            var btn212 = document.getElementById('btn2-12')
            var btn213 = document.getElementById('btn2-13')
            var btn214 = document.getElementById('btn2-14')
            var btn221 = document.getElementById('btn2-21')
            var btn222 = document.getElementById('btn2-22')
            var btn223 = document.getElementById('btn2-23')
            var btn224 = document.getElementById('btn2-24')

            if (this.valuescroll > 450) {
                num2.style.opacity=1
                title2.style.opacity=1
                num2.classList.remove('fadeOutLeft')
                num2.classList.add('fadeInLeft')
                title2.classList.remove('fadeOutRight')
                title2.classList.add('fadeInRight')
            }else if (this.valuescroll < 350  && this.bloque[2]){
                num2.classList.remove('fadeInLeft')
                num2.classList.add('fadeOutLeft')
                title2.classList.remove('fadeInRight')
                title2.classList.add('fadeOutRight')
            }

            if (this.valuescroll > 550) {
                svg20.style.opacity=1
                svg21.style.opacity=1
                texto2.style.opacity=1
                svg20.classList.remove('zoomOut')
                svg20.classList.add('zoomIn')
                svg21.classList.remove('zoomOut')
                svg21.classList.add('zoomIn')
                texto2.classList.remove('zoomOut')
                texto2.classList.add('zoomIn')
            }else if (this.valuescroll < 450  && this.bloque[2]){
                svg20.classList.remove('zoomIn')
                svg20.classList.add('zoomOut')
                svg21.classList.remove('zoomIn')
                svg21.classList.add('zoomOut')
                texto2.classList.remove('zoomIn')
                texto2.classList.add('zoomOut')
            }

            if (this.valuescroll > 550) {
                this.$set(this.bloque, 2,true)
                btn211.style.opacity=1
                btn212.style.opacity=1
                btn213.style.opacity=1
                btn214.style.opacity=1
                btn221.style.opacity=1
                btn222.style.opacity=1
                btn223.style.opacity=1
                btn224.style.opacity=1
                btn211.classList.remove('noclick')
                btn212.classList.remove('noclick')
                btn213.classList.remove('noclick')
                btn214.classList.remove('noclick')
                btn211.classList.remove('bounceOut')
                btn211.classList.add('bounceInLeft')
                btn212.classList.remove('bounceOut')
                btn212.classList.add('bounceInDown')
                btn213.classList.remove('bounceOut')
                btn213.classList.add('bounceInUp')
                btn214.classList.remove('bounceOut')
                btn214.classList.add('bounceInRight')

                btn221.classList.remove('noclick')
                btn222.classList.remove('noclick')
                btn223.classList.remove('noclick')
                btn224.classList.remove('noclick')
                btn221.classList.remove('bounceOut')
                btn221.classList.add('bounceInLeft')
                btn222.classList.remove('bounceOut')
                btn222.classList.add('bounceInDown')
                btn223.classList.remove('bounceOut')
                btn223.classList.add('bounceInUp')
                btn224.classList.remove('bounceOut')
                btn224.classList.add('bounceInRight')
            }else if (this.valuescroll < 450   && this.bloque[2]){
                btn211.classList.add('noclick')
                btn212.classList.add('noclick')
                btn213.classList.add('noclick')
                btn214.classList.add('noclick')
                btn211.classList.remove('bounceInLeft')
                btn211.classList.add('bounceOut')
                btn212.classList.remove('bounceInDown')
                btn212.classList.add('bounceOut')
                btn213.classList.remove('bounceInUp')
                btn213.classList.add('bounceOut')
                btn214.classList.remove('bounceInRight')
                btn214.classList.add('bounceOut')


                btn221.classList.add('noclick')
                btn222.classList.add('noclick')
                btn223.classList.add('noclick')
                btn224.classList.add('noclick')
                btn221.classList.remove('bounceInLeft')
                btn221.classList.add('bounceOut')
                btn222.classList.remove('bounceInDown')
                btn222.classList.add('bounceOut')
                btn223.classList.remove('bounceInUp')
                btn223.classList.add('bounceOut')
                btn224.classList.remove('bounceInRight')
                btn224.classList.add('bounceOut')
            }

            /** Bloque 3 **/
            var num3 = document.getElementById('num-3')
            var title3 = document.getElementById('title-3')
            var svg30 = document.getElementById('svg-30')
            var svg31 = document.getElementById('svg-31')
            var btn311 = document.getElementById('btn3-11')
            var btn312 = document.getElementById('btn3-12')
            var btn313 = document.getElementById('btn3-13')
            var btn314 = document.getElementById('btn3-14')
            var btn321 = document.getElementById('btn3-21')
            var btn322 = document.getElementById('btn3-22')
            var btn323 = document.getElementById('btn3-23')
            var btn324 = document.getElementById('btn3-24')

            if (this.valuescroll > 1200) {
                num3.style.opacity=1
                title3.style.opacity=1
                num3.classList.remove('fadeOutLeft')
                num3.classList.add('fadeInLeft')
                title3.classList.remove('fadeOutRight')
                title3.classList.add('fadeInRight')
            }else if (this.valuescroll < 1100 && this.bloque[3]){
                num3.classList.remove('fadeInLeft')
                num3.classList.add('fadeOutLeft')
                title3.classList.remove('fadeInRight')
                title3.classList.add('fadeOutRight')
            }

            if (this.valuescroll > 1300) {
                svg30.style.opacity=1
                svg31.style.opacity=1
                this.verSvg=true
                svg30.classList.remove('zoomOut')
                svg30.classList.add('zoomIn')
                svg31.classList.remove('zoomOut')
                svg31.classList.add('zoomIn')
            }else if (this.valuescroll < 1200 && this.bloque[3]){
                this.verSvg=false
                svg30.classList.remove('zoomIn')
                svg30.classList.add('zoomOut')
                svg31.classList.remove('zoomIn')
                svg31.classList.add('zoomOut')
            }

            if (this.valuescroll > 1300) {
                this.$set(this.bloque, 3,true)
                btn311.style.opacity=1
                btn312.style.opacity=1
                btn313.style.opacity=1
                btn314.style.opacity=1
                btn321.style.opacity=1
                btn322.style.opacity=1
                btn323.style.opacity=1
                btn324.style.opacity=1
                btn311.classList.remove('noclick')
                btn312.classList.remove('noclick')
                btn313.classList.remove('noclick')
                btn314.classList.remove('noclick')
                btn311.classList.remove('bounceOut')
                btn311.classList.add('bounceInLeft')
                btn312.classList.remove('bounceOut')
                btn312.classList.add('bounceInDown')
                btn313.classList.remove('bounceOut')
                btn313.classList.add('bounceInUp')
                btn314.classList.remove('bounceOut')
                btn314.classList.add('bounceInRight')

                btn321.classList.remove('noclick')
                btn322.classList.remove('noclick')
                btn323.classList.remove('noclick')
                btn324.classList.remove('noclick')
                btn321.classList.remove('bounceOut')
                btn321.classList.add('bounceInLeft')
                btn322.classList.remove('bounceOut')
                btn322.classList.add('bounceInDown')
                btn323.classList.remove('bounceOut')
                btn323.classList.add('bounceInUp')
                btn324.classList.remove('bounceOut')
                btn324.classList.add('bounceInRight')
            }else if (this.valuescroll < 1200 && this.bloque[3]){
                btn311.classList.add('noclick')
                btn312.classList.add('noclick')
                btn313.classList.add('noclick')
                btn314.classList.add('noclick')
                btn311.classList.remove('bounceInLeft')
                btn311.classList.add('bounceOut')
                btn312.classList.remove('bounceInDown')
                btn312.classList.add('bounceOut')
                btn313.classList.remove('bounceInUp')
                btn313.classList.add('bounceOut')
                btn314.classList.remove('bounceInRight')
                btn314.classList.add('bounceOut')


                btn321.classList.add('noclick')
                btn322.classList.add('noclick')
                btn323.classList.add('noclick')
                btn324.classList.add('noclick')
                btn321.classList.remove('bounceInLeft')
                btn321.classList.add('bounceOut')
                btn322.classList.remove('bounceInDown')
                btn322.classList.add('bounceOut')
                btn323.classList.remove('bounceInUp')
                btn323.classList.add('bounceOut')
                btn324.classList.remove('bounceInRight')
                btn324.classList.add('bounceOut')
            }

            /** Bloque 4 **/
            var num4 = document.getElementById('num-4')
            var title4 = document.getElementById('title-4')
            var svg40 = document.getElementById('svg-40')
            var svg41 = document.getElementById('svg-41')
            var texto4 = document.getElementById('texto-4')
            var btn411 = document.getElementById('btn4-11')
            var btn412 = document.getElementById('btn4-12')
            var btn413 = document.getElementById('btn4-13')
            var btn414 = document.getElementById('btn4-14')
            var btn421 = document.getElementById('btn4-21')
            var btn422 = document.getElementById('btn4-22')
            var btn423 = document.getElementById('btn4-23')
            var btn424 = document.getElementById('btn4-24')

            if (this.valuescroll > 1600) {
                num4.style.opacity=1
                title4.style.opacity=1
                num4.classList.remove('fadeOutLeft')
                num4.classList.add('fadeInLeft')
                title4.classList.remove('fadeOutRight')
                title4.classList.add('fadeInRight')
            }else if (this.valuescroll < 1500 && this.bloque[4]){
                num4.classList.remove('fadeInLeft')
                num4.classList.add('fadeOutLeft')
                title4.classList.remove('fadeInRight')
                title4.classList.add('fadeOutRight')
            }

            if (this.valuescroll > 1700) {
                svg40.style.opacity=1
                svg41.style.opacity=1
                texto4.style.opacity=1
                svg40.classList.remove('zoomOut')
                svg40.classList.add('zoomIn')
                svg41.classList.remove('zoomOut')
                svg41.classList.add('zoomIn')
                texto4.classList.remove('zoomOut')
                texto4.classList.add('zoomIn')
            }else if (this.valuescroll < 1600 && this.bloque[4]){
                svg40.classList.remove('zoomIn')
                svg40.classList.add('zoomOut')
                svg41.classList.remove('zoomIn')
                svg41.classList.add('zoomOut')
                texto4.classList.remove('zoomIn')
                texto4.classList.add('zoomOut')
            }

            if (this.valuescroll > 1700) {
                this.$set(this.bloque, 4,true)
                btn411.style.opacity=1
                btn412.style.opacity=1
                btn413.style.opacity=1
                btn414.style.opacity=1
                btn421.style.opacity=1
                btn422.style.opacity=1
                btn423.style.opacity=1
                btn424.style.opacity=1
                btn411.classList.remove('noclick')
                btn412.classList.remove('noclick')
                btn413.classList.remove('noclick')
                btn414.classList.remove('noclick')
                btn411.classList.remove('bounceOut')
                btn411.classList.add('bounceIn')
                btn412.classList.remove('bounceOut')
                btn412.classList.add('bounceIn')
                btn413.classList.remove('bounceOut')
                btn413.classList.add('bounceIn')
                btn414.classList.remove('bounceOut')
                btn414.classList.add('bounceIn')

                btn421.classList.remove('noclick')
                btn422.classList.remove('noclick')
                btn423.classList.remove('noclick')
                btn424.classList.remove('noclick')
                btn421.classList.remove('bounceOut')
                btn421.classList.add('bounceIn')
                btn422.classList.remove('bounceOut')
                btn422.classList.add('bounceIn')
                btn423.classList.remove('bounceOut')
                btn423.classList.add('bounceIn')
                btn424.classList.remove('bounceOut')
                btn424.classList.add('bounceIn')
            }else if (this.valuescroll < 1600 && this.bloque[4] ){
                btn411.classList.add('noclick')
                btn412.classList.add('noclick')
                btn413.classList.add('noclick')
                btn414.classList.add('noclick')
                btn411.classList.remove('bounceInLeft')
                btn411.classList.add('bounceOut')
                btn412.classList.remove('bounceInDown')
                btn412.classList.add('bounceOut')
                btn413.classList.remove('bounceInUp')
                btn413.classList.add('bounceOut')
                btn414.classList.remove('bounceInRight')
                btn414.classList.add('bounceOut')


                btn421.classList.add('noclick')
                btn422.classList.add('noclick')
                btn423.classList.add('noclick')
                btn424.classList.add('noclick')
                btn421.classList.remove('bounceInLeft')
                btn421.classList.add('bounceOut')
                btn422.classList.remove('bounceInDown')
                btn422.classList.add('bounceOut')
                btn423.classList.remove('bounceInUp')
                btn423.classList.add('bounceOut')
                btn424.classList.remove('bounceInRight')
                btn424.classList.add('bounceOut')
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../sass/globals';


.contenido-info{
    max-width: 100%;
    margin: auto;
    position: relative;
    overflow: auto;
    height: calc(50vh + 100px);
    max-height: auto;
    padding: 0px 15px 0px 15px;
    @media screen and (max-width: 500px){
        max-width: 100%;                
    }
}
#svg-00,
#num-1, #title-1, #svg-10, #svg-11, #texto-1
#btn1-11,#btn1-12,#btn1-13,#btn1-14,
#btn1-21,#btn1-22,#btn1-23,#btn1-24,
#num-2, #title-2, #svg-20, #svg-21, #texto-2,
#btn2-11,#btn2-12,#btn2-13,#btn2-14,
#btn2-21,#btn2-22,#btn2-23,#btn2-24,
#num-3, #title-3, #svg-30, #svg-31, #texto-3,
#btn3-11,#btn3-12,#btn3-13,#btn3-14,
#btn3-21,#btn3-22,#btn3-23,#btn3-24,
#num-4, #title-4, #svg-40, #svg-41, #texto-4,
#btn4-11,#btn4-12,#btn4-13,#btn4-14,
#btn4-21,#btn4-22,#btn4-23,#btn4-24
{
    opacity: 0;
}
.ocultar{
    display: none;
}
.content-triangulo{
    position: relative;
    overflow: hidden;
    .subcontent-triangulo{
        display: flex;
        justify-content: center;
        align-items: end;
    }

}
.content{
    position: relative;
    background-attachment: fixed;
    h1{
        text-align: center;
        color: #fff;
    }
}
.content-1{
    background: rgb(4,49,91);
    background: linear-gradient(0deg, rgba(4,49,91,1) 15%, rgba(3,93,123,1) 47%, rgba(3,114,139,1) 100%); 
    height: 292px;
}
.content-2{
    background: #fff;
    p{
        margin: 30px 0 20px 0;
    }
}
.content-22{
    background: #fff;
    p{
        margin: 30px 0 20px 0;
    }
}
.content-3{
    width: 0;
    height: 0;
    border-right: 350px solid transparent;
    border-top: 50px solid #ffffff;
    border-left: 350px solid transparent;
    border-bottom: 50px solid transparent;
    z-index: 1;
}
.content-4{
    background: #a65682;
    height: 487px;
    h1{
        margin-top: 50px;
    }
    .circle{
        text-align: center;
        width: 40px;
        height: 40px;
        -moz-border-radius: 50%;
        -webkit-border-radius: 50%;
        border-radius: 50%;
        background: #843a66;
        margin-right: 10px;
    }
    .subcontent{
        height: 487px;
        /*position: relative;
        background-attachment: fixed;*/
        background-image: url('../assets/unidad1/infografia/prueba1.png');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: bottom;
        background-position-y: 50px;
        .title-sub{
            border-bottom: 2px solid #843a66;
        }
    }
    p{
        color: #fff;
    }
}
.content-5{
    width: 0;
    height: 0;
    border-right: 350px solid transparent;
    border-top: 50px solid #9e517f;
    border-left: 350px solid transparent;
    border-bottom: 50px solid transparent;
    z-index: 1;
    .subcontent{
        height: 487px;
        /*position: relative;
        background-attachment: fixed;*/
        background-image: url('../assets/unidad1/infografia/prueba1.png');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: bottom;
        background-position-y: 50px;
        .title-sub{
            border-bottom: 2px solid #843a66;
        }
    }
}
.content-6{
    background: #f29f80;
    height: 487px;
    h1{
        margin-top: 50px;
    }
    .circle{
        text-align: center;
        width: 40px;
        height: 40px;
        -moz-border-radius: 50%;
        -webkit-border-radius: 50%;
        border-radius: 50%;
        background: #e56c6c;
        margin-right: 10px;
    }
    .subcontent{
        height: 487px;
        /*position: relative;
        background-attachment: fixed;*/
        background-image: url('../assets/unidad1/infografia/prueba2.png');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: bottom;
        background-position-y: 50px;
        .title-sub{
            border-bottom: 2px solid #e56c6c;
        }
    }
    p,h1{
        color: #070707;
    }
}
.content-7{
    width: 0;
    height: 0;
    border-right: 350px solid transparent;
    border-top: 50px solid #ea967d;
    border-left: 350px solid transparent;
    border-bottom: 50px solid transparent;
    z-index: 1;
}
.content-8{
    background: #50bfbf;
    height: 487px;
    h1{
        margin-top: 50px;
    }
    .circle{
        text-align: center;
        width: 40px;
        height: 40px;
        -moz-border-radius: 50%;
        -webkit-border-radius: 50%;
        border-radius: 50%;
        background: #03738c;
        color: #fff;
        margin-right: 10px;
    }
    .subcontent{
        height: 487px;
        /*position: relative;
        background-attachment: fixed;*/
        background-image: url('../assets/unidad1/infografia/prueba3.png');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: bottom;
        background-position-y: 50px;
        .title-sub{
            border-bottom: 2px solid #03738c;
        }
    }
    p,h1{
        color: #070707;
    }
}
.content-9{
    width: 0;
    height: 0;
    border-right: 350px solid transparent;
    border-top: 50px solid #4bb5b2;
    border-left: 350px solid transparent;
    border-bottom: 50px solid transparent;
    z-index: 1;
}
.content-10{
    background: #fff983;
    height: 487px;
    h1{
        margin-top: 50px;
    }
    .circle{
        text-align: center;
        width: 40px;
        height: 40px;
        -moz-border-radius: 50%;
        -webkit-border-radius: 50%;
        border-radius: 50%;
        background: #d3d300;
        margin-right: 10px;
    }
    .subcontent{
        height: 487px;
        /*position: relative;
        background-attachment: fixed;*/
        background-image: url('../assets/unidad1/infografia/prueba4.png');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: bottom;
        background-position-y: 50px;
        .title-sub{
            border-bottom: 2px solid #d3d300;
        }
    }
    p,h1{
        color: #070707;
    }
}
.content-11{
    width: 0;
    height: 0;
    border-right: 350px solid transparent;
    border-top: 50px solid #f7ee7f;
    border-left: 350px solid transparent;
    border-bottom: 50px solid transparent;
    z-index: 1;
}

.content-4,.content-6,.content-8,.content-10{
    margin-top: -100px;
}
.content-2,.content-3{z-index: 1;}

/* */
.cont-img{
    display: flex;
    justify-content: center;
}

/* Tarjeta */
.card-modal{
    position: relative;
}
.card-parent{
    margin-top: 100px;
    position: absolute;
    background: #2d2d2d85;
    display: flex;
    justify-content: center;
    align-items: center;
    height: auto;
    z-index: 1;
    width: 100%;
    .card-son{
        margin: 20px 0 20px 0;
        background: #FFF;
        width: 90%;
        height: 80%;
        overflow: auto;
        .card-parrafo{
            width: 100%;
            padding: 10px 15px 10px 15px;
            color: #070707;
            ul, li, p {
                margin-top: 10px;
                font-size: 1.2rem;
            }
            li {
                font-size: 1.2rem;
                line-height: 1.5rem;
            }
            p{
            color: #070707;
            }
            .card-parrafo-texto{
                font-size: 1.2rem;
                color:#070707;
                li{
                    font-size: 1.5rem;
                }
            }
            .card-parrafo-titulo{
                width: 100%;
                font-family: FontBase-BoldItalic;
            }

        }
    }
}
.cont-title{
    display: flex;
    justify-content: center;
}
/* Botones */
button{
    background: #fff;
    padding: 10px 15px 10px 15px;
    margin: 0 5px 0 5px;
    line-height: 1.3rem;
    border-radius: 5%;
    font-size: 1rem;
    z-index: 1.2;
    font-family: FontBase-Bold;
}
.btn{
    background: #fff;
    padding: 10px 15px 10px 15px;
    margin: 0 5px 0 5px;
    line-height: 1.3rem;
    border-radius: 5%;
    font-size: 1rem;
    height: 100%;
    z-index: 1.2;
    font-family: FontBase-Bold;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    cursor: pointer;

}
.content-4{.btn{color:$color-secondary;}}
.content-6,.content-8,.content-10{.btn{color:#070707;}}

/* Contenedor 1 */
.contenidoCurso{
  background: rgb(4,49,91);
  background: linear-gradient(0deg, rgba(4,49,91,1) 15%, rgba(3,93,123,1) 47%, rgba(3,114,139,1) 100%); 
}
.portada-contenedor-fondo{
  display: flex;
  justify-content: center;

}
.portada-linea{
  height: 10px;
}
.portada-mensaje,.portada-autor{
  color:#fff;
  text-align: center;
  font-family: FontBase-Italic;
  font-size: 1.5rem;
}
.portada-autor{
  text-align: end;
}
.contenedor-logo{
      width: 100%;
      padding-top: 20px;
      padding-bottom: 20px;
      z-index: 2;
}

.portada-logo-montanas{
  position: absolute;
  width: 100%;
  bottom: -7px;
  left: 0;
  z-index: 0;
  img.img-logo{
      padding: 0px;
  }
}
/*.portada-logo-estructura{
  //position: absolute;
  width: 100%;
  //bottom: -7px;
  left: 0;
  bottom: 0;
  z-index: 1;
  img.img-logo{
      //padding: 0px 3px 0px 3px;
      padding: 0;
  }
}*/

.portada-logo-estructura{
    position: relative;
    overflow: hidden;
    .portada-logo-estructura-sub{
        display: flex;
        justify-content: center;
        align-items: end;
        img{
            width: 15rem;
        }

    }
}
/* Versión sm */
@media (max-width: 600px) {
    .content-4,.content-6,.content-8,.content-10{
        height: 650px;
        .subcontent{
            height: 650px;
            position: relative;
            background-attachment: fixed;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
            background-position-y: 90%;
        }
    }

    .content-5{
        border-top: 50px solid #a65682;
    }
    .content-7{
        border-top: 50px solid #f29f80;
    }
    .content-9{
        border-top: 50px solid #50bfbf;
    }
    .content-11{
        border-top: 50px solid #fff983;
    }

    
}

.tittle-big{
  text-align: left;
  font-family: FontBase-Regular;
  color:$color-inverted;
  text-align: center;
  .title-big-sub{
  font-family: FontBase-SemiBold;
  }
}
.tittle-small{
  text-align: left;
  color: $color-inverted;
  font-family: FontBase-LightItalic;
  text-align: center;
}
</style>